<template>
  <div v-if="pages.length > 0" class="text-center uppercase">
    page
    <component v-for="page in pages" :key="page"
               :is="!isCurrentPage(page) ? 'a' : 'span'"
               @click="goToPage(page)"
               :class="[{ 'bg-primary text-white': isCurrentPage(page) }, 'pl-2 pr-1 cursor-pointer mx-1 rounded cursor-pointer']">
      {{ page }}
    </component>
  </div>
</template>

<script lang="ts">

// See https://class-component.vuejs.org/ for more details on class style components in Vue
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

const SearchPaginationProps = Vue.extend({
    props: {
      rowsPerPage: {
        type: Number
      },
      total: {
        type: Number
      },
      pageChanged: {
        type: Function as PropType<(any) => void>
      },
      perPageChanged: {
        type: Function as PropType<(any) => void>,
      },
    }
});
@Component<SearchPagination>({
  watch: {
    total(newTotal: number) { this.updatePages(newTotal) },
    rowsPerPage(newRowsPerPage: number) { this.updatePage(this.total) }
  }
})
export default class SearchPagination extends SearchPaginationProps {
  pages: number[] = [];
  currentPage: number = null;

  goToPage(customCurrentPage) {
    this.pageChanged({currentPage: customCurrentPage});
    this.currentPage = customCurrentPage;
  }

  mounted() {
  }

  isCurrentPage(page: number): boolean {
    return page === this.currentPage;
  }

  updatePages(newTotal: number) {
    if (newTotal > 0  && this.rowsPerPage > 0) {
      // The number of pages needs to be rounded up so that we always have enough room
      // to show the data
      const numberOfPages = Math.ceil(newTotal / this.rowsPerPage);

      // Create a new array of sequential page numbers
      const newPageArray = [];
      for(let i = 1; i <= numberOfPages; i++) { newPageArray.push(i)}

      // Set the new page array and reset the current page
      this.pages = newPageArray;
      this.currentPage = 1;
    } else {
      this.pages = [];
      this.currentPage = 0;
    }
  }
}
</script>
